import { ColumnDef } from '@tanstack/react-table'
import { FamilyDataMock } from '@type/history.type'
import { Table2 } from '@ui'
import { useMemo } from 'react'
import { patientHistoryTableClassName } from '../Results/tableStyles'

export default function FamilyHistoryTable({ isLoading, records }: { isLoading?: boolean; records: FamilyDataMock[] }) {
  const columns = useMemo<ColumnDef<FamilyDataMock>[]>(
    () => [
      {
        accessorKey: 'relationship',
        header: 'Relationship',
        cell: ({ row }) => <span className="capitalize">{row.original.attributes.relationship || '-'}</span>
      },
      {
        accessorKey: 'medicalConditions',
        header: 'Medical Conditions',
        cell: ({ row }) => <span>{row.original.attributes.medical_conditions?.join(', ') || '-'}</span>
      }
    ],
    []
  )

  return (
    <Table2
      className={patientHistoryTableClassName}
      columns={columns}
      data={records}
      emptyDescription="No history found."
      isLoading={isLoading}
      message="No history found"
      showPagination={false}
      wrapperClass="overflow-x-auto"
    />
  )
}
